import { useMutation } from '@tanstack/react-query';
import { createUrl } from 'src/core/api/utils/createUrl';
import { fetch as fetchRedirect } from 'src/utils/refetch';

export type PaymentDataModel = {
  product_price_id: number | undefined;
  product_id: number;
  id: string | number | undefined;
  gateway: string;
  redirect_url: string;
};

const usePaymentMutation = () => {
  const { mutate, isLoading } = useMutation({
    mutationFn: async (data: PaymentDataModel) => {
      const response = await fetchRedirect(createUrl('/payment/charge'), {
        method: 'POST',
        body: JSON.stringify(data),
      });
      if (!response.response.ok) {
        return response.body;
      }
      return response.body;
    },
  });
  return { mutate, isLoading };
};

export default usePaymentMutation;
